import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

export default {
  props: {
    config: {
      default: function _default() {
        return {};
      }
    },
    formValue: {
      default: function _default() {
        return {};
      }
    },
    model: {
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formConfig: {
        labelWidth: '30px'
      }
    };
  },

  computed: {
    formModel: function formModel() {
      var value = this.formValue[this.config.prop];
      if (!Array.isArray(value)) {
        try {
          value = JSON.parse(this.formValue[this.config.prop] || '{}').nine || [0, 0, 0, 0];
        } catch (e) {
          value = [0, 0, 0, 0];
        }
      }

      var _value = value,
          _value2 = _slicedToArray(_value, 4),
          l = _value2[0],
          t = _value2[1],
          r = _value2[2],
          b = _value2[3];

      return {
        l: l || 0,
        r: r || 0,
        t: t || 0,
        b: b || 0
      };
    },
    schema: function schema() {
      var _this = this;

      return {
        type: 'object',
        properties: {
          l: {
            title: '左',
            component: 'input',
            field: {
              min: 0,
              type: 'number',
              style: {
                maxWidth: '200px'
              },
              listeners: {
                input: function input(value) {
                  _this.$emit('change', {
                    value: value,
                    index: 0,
                    $index: _this.formValue.$index
                  });
                }
              }
            }
          },
          r: {
            component: 'input',
            title: '右',
            field: {
              min: 0,
              type: 'number',
              style: {
                maxWidth: '200px'
              },
              listeners: {
                input: function input(value) {
                  _this.$emit('change', {
                    value: value,
                    index: 2,
                    $index: _this.formValue.$index
                  });
                }
              }
            }
          },
          t: {
            component: 'input',
            title: '上',
            field: {
              min: 0,
              type: 'number',
              style: {
                maxWidth: '200px'
              },
              listeners: {
                input: function input(value) {
                  _this.$emit('change', {
                    value: value,
                    index: 1,
                    $index: _this.formValue.$index
                  });
                }
              }
            }
          },
          b: {
            component: 'input',
            title: '下',
            field: {
              min: 0,
              type: 'number',
              style: {
                maxWidth: '200px'
              },
              listeners: {
                input: function input(value) {
                  _this.$emit('change', {
                    value: value,
                    index: 3,
                    $index: _this.formValue.$index
                  });
                }
              }
            }
          }
        }
      };
    }
  }
};